var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenComputer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 511.6 425.33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "men_computer") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "be406034-3731-4bf6-92f5-95d620ed805b",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a1b90205-5952-46b0-bf8d-34359da92755",
    "data-name": "BACKGROUND"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M481.88,348.29c-13.35,43.66-78.09-7.42-79.12,35s-101.22,44.94-156.2,39.43-31.34-42.4-74-44.94S68.78,386.82,46.18,335.1,32.82,185.93,34.36,133.36,75,109.2,76,70.2c.51-19.38,6.47-34.58,22-46.27a2.11,2.11,0,0,1,.23-.16C100.6,22.12,121,8.43,147.82,11c28.52,2.7,37.36,11.64,40.66,36.22s52.83,22.74,49.63-16.27S321.8.07,348.24,2.06c18.81,3,32.26,7.42,35,13.87,10.79,25.44.52,58.51,23.64,57.66s68.33-2.12,74.5,38.58S495.24,304.63,481.88,348.29Z",
    fill: "#fdd686"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M206,315.62c49,0,38.24-50.28,39.43-68.51s-9-43.88-40.62-43.88-28.08,37-28.08,59.16S175.5,315.62,206,315.62Z",
    fill: "#df9334"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.19,357c40.61,0,31.69-41.67,32.68-56.79s-7.43-36.36-33.67-36.36-23.28,30.64-23.28,49S78.93,357,104.19,357Z",
    fill: "#df9334"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.55,249.27c37.84,0,39.42-46.83,38.63-81.3s1.57-77.4-44.15-77.4-36.26,55.94-37,85.21S61.83,249.27,107.55,249.27Z",
    fill: "#df9334"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.55,232.33c21.69,0,26.57-52.79-2.17-52.79S78.81,232.33,107.55,232.33Z",
    fill: "#e9b36b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.57,76.38c21.69,0,26.57-52.79-2.17-52.79S266.83,76.38,295.57,76.38Z",
    fill: "#e9b36b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.91,361.4c-43.14-4.59-40.49-43.93-40.49-105.8s6.74-113.21,23.24-139.82,66.74-55.06,95.23-47.63,40.49,37.74,17.25,56.92-36.74,37.12-39,74.24-3,71.76-6.75,116.31S339.15,363.87,315.91,361.4Z",
    fill: "#df9334"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.12,336.73c-33.27,0-35.69-86.61,4.87-86S361.94,336.73,318.12,336.73Z",
    fill: "#e9b36b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.47,257c-33.28,0-35.7-86.61,4.87-86S477.28,257,433.47,257Z",
    fill: "#e9b36b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "aeb8f8c6-822f-446c-9184-f57dd1c57ad3",
    "data-name": "DOTS"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 427.49,
    cy: 156.3,
    r: 6.63,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 94.32,
    cy: 370.4,
    r: 2.5,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 393.2,
    cy: 419.22,
    r: 5.1,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 299.7,
    cy: 31.21,
    r: 3.29,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 74.25,
    cy: 174.19,
    r: 5.41,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 257.58,
    cy: 16.46,
    r: 1.78,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 71.13,
    cy: 257.43,
    r: 2.41,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225.74,
    cy: 416.44,
    r: 5.22,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 158.52,
    cy: 279.76,
    r: 3.21,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 431.41,
    cy: 299.44,
    r: 3.15,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "e4bca6b0-2db8-4c77-a70d-436528a5a915",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M393.87,119c5.69-1.48,11.42-2.84,17.16-4,2.84-.59,5.69-1.11,8.54-1.63,1.43-.27,2.85-.52,4.28-.75s2.82-.31,3.83-1.47a1,1,0,0,0-.2-1.53c-1.23-.78-2.43-.54-3.8-.33s-3,.49-4.52.76c-2.93.52-5.84,1.15-8.74,1.83-5.81,1.36-11.51,3-17.16,4.92a1.16,1.16,0,0,0,.61,2.23Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.51,109.56a34.45,34.45,0,0,1,4.87-.33c.82,0,1.63,0,2.45,0s1.8.16,2.54-.46l-.4.23a1.45,1.45,0,0,0,.77-.43.67.67,0,0,0,0-.91,1.59,1.59,0,0,0-.77-.43l.4.24a3.33,3.33,0,0,0-2.54-.38,20.79,20.79,0,0,0-2.6.34c-1.63.31-3.26.59-4.88,1-.63.14-.51,1.23.16,1.15Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.78,126.9c1.21,1.14,2.45,2.24,3.65,3.37.57.54,1.13,1.08,1.67,1.64a5.9,5.9,0,0,0,1,1,6,6,0,0,0,1.15.54,1.28,1.28,0,0,0,1.26-.33,1.38,1.38,0,0,0,.33-1.26,4.12,4.12,0,0,0-.41-1.21,5.49,5.49,0,0,0-.91-1.08c-.55-.57-1.12-1.13-1.7-1.68-1.2-1.14-2.43-2.26-3.64-3.39a1.72,1.72,0,0,0-2.43,2.43Z",
    fill: "#edd3a5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.86,109.07c5.31,1.55,10.51,3.42,15.66,5.43a50.77,50.77,0,0,1,14.22,8.09c1.67,1.4,4.09-1,2.4-2.4A54.27,54.27,0,0,0,466,111.66c-2.71-1-5.44-2-8.23-2.77a35.58,35.58,0,0,0-8.69-1.39.8.8,0,0,0-.22,1.57Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503,152.88a26.67,26.67,0,0,0-.58-6.24c-.24-1-.52-2-.85-2.92a7.56,7.56,0,0,0-.65-1.52,5.09,5.09,0,0,0-.64-.74,2.9,2.9,0,0,0-.68-.53,1.14,1.14,0,0,0-1.66.67,2,2,0,0,0-.09.49,1,1,0,0,0,0,.55c0-.37,0-.3-.05.2a4.34,4.34,0,0,0,.08.52,9.4,9.4,0,0,0,.49,1.44q.51,1.33.9,2.7a56.23,56.23,0,0,1,1.44,5.68c.22,1.31,2.25,1,2.26-.3Z",
    fill: "#edd3a5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.62,163.51c-.07,3.62-.34,7.28-.62,10.9a61.35,61.35,0,0,1-1.81,10.84,68,68,0,0,1-8.63,19.8c-2.22,3.44-5.05,6.63-6.73,10.38a1,1,0,0,0,1.33,1.33c3.45-1.68,6-4.93,8.16-8a65.36,65.36,0,0,0,5.63-10,66.68,66.68,0,0,0,5.62-22.51,46.26,46.26,0,0,0,.06-6.34,38.72,38.72,0,0,0-1.17-6.59.94.94,0,0,0-1.84.25Z",
    fill: "#edd3a5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.06,221.26a58.26,58.26,0,0,1-5,5.42c-.44.41-.91.79-1.37,1.19l-.65.56-.4.32-.11.08a16,16,0,0,1-1.49,1,2.8,2.8,0,0,0-1.65,2.27l.41-1a2.29,2.29,0,0,0-.53,1,1,1,0,0,0,.42,1,1.91,1.91,0,0,0,1.09.3l-.7-.19c1.6,1,3.37-.6,4.58-1.55a18.28,18.28,0,0,0,2.71-2.64,62.94,62.94,0,0,0,4.54-6.42c.7-1.1-1-2.44-1.85-1.42Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.3,233.39c-2.29,1.15-4.61,2.22-7,3.17-1.16.46-2.33.9-3.5,1.33l-1.76.63a7.85,7.85,0,0,0-2.24.9A2.11,2.11,0,0,0,442,242a2.13,2.13,0,0,0,2.44,1.2,7.66,7.66,0,0,0,2.21-1l1.66-.88c1.15-.61,2.28-1.23,3.41-1.87,2.3-1.31,4.6-2.62,6.88-4a1.23,1.23,0,0,0-1.25-2.12Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.47,240.35c-2.17-.19-4.3-.44-6.48-.49s-4.49,0-6.74,0c-4.32,0-8.64,0-13,.08a105.9,105.9,0,0,1-13-.18c-4.17-.42-8.22-1.56-12.4-1.93s-8.52-.07-12.78-.16a59.72,59.72,0,0,1-12.39-1.77c-8.38-2-16.69-4.32-25-6.5-4.74-1.25-9.47-2.51-14.22-3.7s-9.55-2.53-14.56-2.55a1,1,0,0,0-.52,1.89,52.34,52.34,0,0,0,12.22,4.47c4.24,1.16,8.5,2.28,12.75,3.4,8.54,2.25,17.07,4.55,25.62,6.72A83,83,0,0,0,362.49,242c4.32.41,8.66.1,13,.19s8.41,1,12.64,1.57a73.73,73.73,0,0,0,12.95.44c4.9-.18,9.79-.49,14.69-.75,2.49-.13,5-.21,7.48-.42s5-.6,7.46-1c1-.16.66-1.61-.23-1.69Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.06,222.12c-4.23-.72-8.45-1.44-12.71-2-2.06-.27-4.13-.57-6.2-.79s-4.49-.84-6.39,0c-1,.47-.7,1.76,0,2.3,1.49,1.14,4.11,1.05,5.91,1.27,2.14.26,4.3.43,6.44.63,4.21.4,8.42.63,12.64.86,1.3.07,1.63-2.08.31-2.3Z",
    fill: "#edd3a5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.13,220.05l-5.63-1.31c-1.85-.42-3.84-1-5.73-.68-.62.1-.64,1-.17,1.28,1.6,1,3.64,1.14,5.46,1.41l5.64.84c1,.15,1.46-1.3.43-1.54Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.64,217.09a80.52,80.52,0,0,0-8.48-.8q-4.24,0-8.47.1-8.48.31-16.89,1.32a237.37,237.37,0,0,0-33.32,6.47c-3,.82-6,1.71-9,2.65s-6.44,1.8-9.15,3.65c-1.15.78-.88,3,.78,2.87a37.86,37.86,0,0,0,8.11-2.18c2.68-.87,5.39-1.7,8.11-2.47q8-2.28,16.23-4a248.32,248.32,0,0,1,33-4.47q4.69-.33,9.41-.51c3.24-.13,6.42-.51,9.66-.73a1,1,0,0,0,0-1.91Z",
    fill: "#edd3a5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.63,234.76a32.73,32.73,0,0,0-7.42,2,28.39,28.39,0,0,0-3.27,1.62,9.89,9.89,0,0,0-1.73,1.2,2,2,0,0,0-.43.49l-.18.41c0,.5-.07.6,0,.3s0-.2,0-.06a1.33,1.33,0,0,0-.11.24,2.05,2.05,0,0,0-.11.6,1.07,1.07,0,0,0,.78,1,1.93,1.93,0,0,0,.47.08c.06,0,.5-.12.54-.08l-.27,0,.46.07a2,2,0,0,0,.86-.24,15.61,15.61,0,0,0,1.53-.89c1-.64,2.06-1.28,3.13-1.86a50.28,50.28,0,0,1,6.34-3.11.94.94,0,0,0-.49-1.81Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.77,252.86a36.32,36.32,0,0,0-6.14,5.33c-.92,1.06-1.81,2.15-2.66,3.26a22.6,22.6,0,0,0-2.32,3.42,1.78,1.78,0,0,0,.28,2.1,1.83,1.83,0,0,0,.76.45,1.77,1.77,0,0,0,2-.8c.78-1,1.43-2.18,2.15-3.26s1.47-2.13,2.26-3.15c1.57-2,3-4.11,4.7-6.07.55-.65-.19-1.87-1-1.28Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.56,351.92a9.33,9.33,0,0,0,2.29,2.89,13.24,13.24,0,0,0,3.42,2,13.58,13.58,0,0,0,3.53,1,7.22,7.22,0,0,0,2-.07,2.32,2.32,0,0,0,1-.33s.33-.23.14-.12a4.84,4.84,0,0,1,.47-.21.57.57,0,0,0-.13-1c-.52-.15-1-.43-1.5-.54s-1.06-.26-1.6-.35a16,16,0,0,1-3.19-.85,19.51,19.51,0,0,1-2.7-1.46A30.08,30.08,0,0,1,103.5,351c-.59-.44-1.23.39-.94.93Z",
    fill: "#edd3a5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.43,356.51c5.09,2.36,11.33.68,16.28-1.31,2.75-1.11,5.43-2.38,8.16-3.54s5.8-2.22,8.77-3.15c12.44-3.88,25-7.4,37.63-10.65q5.22-1.33,10.48-2.59c1.75-.41,3.51-.8,5.26-1.23,1-.23,1.9-.51,2.83-.82a9.36,9.36,0,0,0,2.38-1.43c.55-.38.61-1.48-.21-1.61a17.57,17.57,0,0,0-2.15-.37,15,15,0,0,0-2.39.38c-1.61.27-3.19.71-4.78,1.1-3.1.77-6.18,1.57-9.28,2.36q-9.39,2.4-18.72,5c-6.14,1.73-12.27,3.51-18.36,5.42a144.7,144.7,0,0,0-17,6.49,67.19,67.19,0,0,1-9.08,3.64,27,27,0,0,1-9.48.82.78.78,0,0,0-.39,1.45Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.45,330c1.08,0,2.16,0,3.24,0s2,.16,3,.12,2-.18,3-.29a6.35,6.35,0,0,0,2-.45,4.06,4.06,0,0,0,1.38-.79,1.19,1.19,0,0,0-.24-1.84,3.88,3.88,0,0,0-1.53-.35,7.24,7.24,0,0,0-1.8.07l-3,.44c-1,.15-2,.46-3,.65s-2,.29-3,.41a1,1,0,0,0,0,2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.41,329.8c6.68-1,13.61.1,20.16,1.44,3.33.68,6.65,1.42,10,2s7.15,1,10.32-.26a.83.83,0,0,0,0-1.58c-3.19-1.16-6.83-1.42-10.17-2-3.5-.61-7-1.41-10.43-2.09-6.87-1.36-13.79-2.25-20.53.14a1.23,1.23,0,0,0,.65,2.37Z",
    fill: "#edd3a5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.33,334.63c4.46,1.39,8.89,2.81,13.37,4.11,2.36.69,4.69,1.46,7.06,2.11,1.08.3,2.19.49,3.29.74a15.94,15.94,0,0,0,3.05.58.9.9,0,0,0,.45-1.67,13.64,13.64,0,0,0-2.69-1.23c-1-.41-2.08-.87-3.14-1.23-2.37-.8-4.85-1.36-7.27-2-4.52-1.21-9.06-2.2-13.65-3.09a.88.88,0,0,0-.47,1.69Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.83,345c3.28,1.87,6.41,3.91,9.76,5.64,2.73,1.41,5.57,2.62,8.38,3.88,5.25,2.36,10.53,4.63,15.7,7.18q2.67,1.31,5.29,2.67l2.93,1.53c1.07.57,2.11,1.37,3.36,1.32a1.49,1.49,0,0,0,1.27-2.21c-1-1.57-3.47-2.37-5.07-3.2s-3.24-1.67-4.88-2.47q-4.19-2.07-8.43-4c-5.3-2.39-10.66-4.64-16-6.87-3.92-1.63-8-2.79-11.93-4.33-.5-.2-.81.6-.36.85Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ea38d677-108b-4c9d-964e-07fbae4c1328",
    "data-name": "MAN'S COMPUTER"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M222.3,121.19s-14.11-3.34-23.14,21.39c-5.51,15-51.82,109.84-51.82,109.84-1.76,33.06,20.3,39.88,55.71,32l5.33.13c13.65-16.1,47.42-88.7,47.42-88.7Z",
    fill: "#ac2020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.91,116.24a46.25,46.25,0,0,0-9.6,4.1c-2.56,1.49-5.27,3.39-6.83,6-.45.74.67,1.66,1.23,1,3.86-5,9.68-7.77,15.58-9.6.9-.28.52-1.68-.38-1.41Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.15,144.88a43.2,43.2,0,0,1,3.65-7c.74-1.28,1.52-2.54,2.31-3.79.33-.52.66-1,1-1.55a3.9,3.9,0,0,0,.68-1.33c0-.28-.19-.61-.5-.5-1,.37-1.7,1.69-2.28,2.56-.84,1.27-1.6,2.62-2.33,4a39.16,39.16,0,0,0-3.42,7.41c-.18.58.68.8.88.25Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.91,267.36c0,1.7-.08,3.3-.16,4.77A38.2,38.2,0,0,1,213,284.71c-14.83,6.08-53.19,6.81-65.45-.47-1.41-4.29-2.25-8.17-2.25-8.17s-.18-2.54-.35-6.2c-.43-8.34-.91-22.5.35-26,1.82-5.1,20.95-1.93,21.57-2.19s11.71-3.66,15.06-3.3,12.35,5,13.37,5,10.82-3.93,15.63-2.23C215.1,242.55,216.12,256.56,215.91,267.36Z",
    fill: "#ca8073"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.91,267.36c0,1.7-.08,3.3-.16,4.77A38.2,38.2,0,0,1,213,284.71c-14.83,6.08-53.19,6.81-65.45-.47-1.41-4.29-2.25-8.17-2.25-8.17s-.18-2.54-.35-6.2c4.85,4.47,13.94,4.17,23.22-4.3,0,0,4.38,7.91,15,7.16s12-8.84,12-8.84S201.24,275.16,215.91,267.36Z",
    fill: "#bb6a5c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.18,250.57s-.31,25.89,2,31",
    fill: "none",
    stroke: "#192d3c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.24,252.42s-.29,21-1.28,29.85",
    fill: "none",
    stroke: "#192d3c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "292.96 121.51 303.52 121.75 305.76 99.63 306.08 96.46 295.26 96.85 293.93 111.08 292.96 121.51",
    fill: "#bb6a5c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.93,111.08c5.88-2.31,9.69-7.54,11.83-11.45l.32-3.17-10.82.39Z",
    fill: "#192d3c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.65,102.11a8.53,8.53,0,0,0,5.55,2.06c4.44.2,9.75-2.06,13.38-5.91a16.7,16.7,0,0,0,3.08-4.68,25.09,25.09,0,0,0,2.17-9.69,23.37,23.37,0,0,0-.06-7.77,10.09,10.09,0,0,0-4.4-6.77,13.91,13.91,0,0,0-5.43-1.92c-9.88-1.54-15.32,6.08-16.12,13.59S284.16,98.07,288.65,102.11Z",
    fill: "#ca8073"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.2,104.17c4.44.2,9.75-2.06,13.38-5.91a16.7,16.7,0,0,0,3.08-4.68,25.09,25.09,0,0,0,2.17-9.69,23.37,23.37,0,0,0-.06-7.77,10.09,10.09,0,0,0-4.4-6.77,1.23,1.23,0,0,0-.32.48,17.88,17.88,0,0,1-3.41,5S303.38,96.14,294.2,104.17Z",
    fill: "#bb6a5c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.85,90l-.23,3.47,4,.14a25.09,25.09,0,0,0,2.17-9.69,23,23,0,0,0-.06-7.76c-2.61-.35-7,4.26-7,4.26l-.66,8Z",
    fill: "#192d3c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.55,77.77A47.43,47.43,0,0,0,302.35,82,35.53,35.53,0,0,0,315.11,81a24.76,24.76,0,0,0,.42-4.21c.17-5.57-1.15-14.89-11.63-16.48l-.23,0c-10.74-1.47-14.76,6.59-16.25,12.28A26.92,26.92,0,0,0,286.55,77.77Z",
    fill: "#d62828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.35,82A35.53,35.53,0,0,0,315.11,81a24.76,24.76,0,0,0,.42-4.21c.17-5.57-1.15-14.89-11.63-16.48l-.23,0A39.45,39.45,0,0,1,302.35,82Z",
    fill: "#ac2020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.55,77.77a47.54,47.54,0,0,0,16.66,4.32A35.21,35.21,0,0,0,315.11,81a24.76,24.76,0,0,0,.42-4.21,56.26,56.26,0,0,1-10.87.52,37.6,37.6,0,0,1-17.24-4.76A26.92,26.92,0,0,0,286.55,77.77Z",
    fill: "#f77f00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.21,82.09A35.21,35.21,0,0,0,315.11,81a24.76,24.76,0,0,0,.42-4.21,56.26,56.26,0,0,1-10.87.52A44.68,44.68,0,0,1,303.21,82.09Z",
    fill: "#b85f00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.23,79h0a2.57,2.57,0,0,1-1,3.29c-3.31,2-11,5.42-22.92,3C287,83,282.07,78.81,280.12,76.43a2.46,2.46,0,0,1,0-3.16h0a2.47,2.47,0,0,1,3.63-.17,26.65,26.65,0,0,0,15.48,7.11,36.92,36.92,0,0,0,19.63-2.53A2.57,2.57,0,0,1,322.23,79Z",
    fill: "#d62828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.74,89.66s3.08-4.53,6.67-2.13-.16,15.07-9.55,9.54Z",
    fill: "#bb6a5c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.22,264.17l12.86-70.8L370.5,117.9s-31.06,9.58-71.33,5c0,0-45.48.85-77.43-1.79,0,0-8.4,96.17,2.07,154l-5.07,22.66H382.51C376.24,279.05,371.22,264.17,371.22,264.17Z",
    fill: "#d62828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.33,291.26c-5.21-15.54-9.1-27.09-9.1-27.09l.23-4.86,1.88-40.07c-12.9,18.16-31.71,35.23-46.66,46-7.42,5.34-13.88,9.13-18.21,10.75a50.94,50.94,0,0,1-15.89,2.62c-17.79.55-39.76-4.36-52.38-7.23-16.84-3.82,13.35,11.07,30.29,19.63,3.56,1.8,4.55,4.19,3.61,6.74H382.5Z",
    fill: "#8e2429"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.69,285c0,6.36,13.15,11.46,17.82,11.46s8.9-5.94,8.9-5.94,7.63,7.63,16.11,7.21c5.73-.29,31-4.06,46.81-6.47-5.21-15.54-9.1-27.09-9.1-27.09l.23-4.86-44.78,5.93-27.51,3.65a54.33,54.33,0,0,0-6.59,9.72A15.17,15.17,0,0,0,290.69,285Z",
    fill: "#6d1c21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.65,256.51s-1,20.19-1.66,41.2",
    fill: "none",
    stroke: "#192d3c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 287.46,
    cy: 275.98,
    r: 4.6,
    fill: "#192d3c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.52,113.77a261.42,261.42,0,0,1-29.21,1.5q-7.32-.06-14.63-.62A50.13,50.13,0,0,0,220,115c-.92.18-.53,1.58.38,1.41,4.81-.91,9.43-.54,14.27-.2s9.59.52,14.39.5a172.75,172.75,0,0,0,28.55-2.35c.31-.06.24-.58-.07-.55Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362,112c-12.21,1.25-24.4,2.68-36.59,4-1.11.12-1.12,1.87,0,1.74,12.27-1.39,24.51-2.95,36.71-4.92.48-.07.37-.91-.12-.86Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.87,195.4c-5.4,11-8.57,28.37-8.57,28.37l29.75,23.13,39.74-14.69c2.31-11,1.49-34.61,1.49-34.61l17.59-2.46c8.47-35.69-.7-62.72-.7-62.72a137.19,137.19,0,0,0-14.29-3.49,145.92,145.92,0,0,0-46.32-1.27,101.76,101.76,0,0,0-15,3c-8.1,14-15.7,58.75-15.7,58.75Z",
    fill: "#8e2429"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.87,193c-5.4,11.57-7.33,25.44-7.33,25.44l28.51,28.5,41.23-20.42c2.31-11.56,0-31.21,0-31.21l17.34-3.84c8.46-37.38-1.8-68.95-1.8-68.95a91.94,91.94,0,0,0-12.94.86A139.37,139.37,0,0,0,272.56,122a112.21,112.21,0,0,0-15.28-.17c-8.1,14.7-15,63.06-15,63.06Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.2,243.82c24.22-39.63,40.06-108.5,42.68-120.48A139.37,139.37,0,0,0,272.56,122C266.28,185.53,276.2,243.82,276.2,243.82Z",
    fill: "#005d8f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.06,138.88S279.62,195.38,277,230",
    fill: "none",
    stroke: "#192d3c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.06,114.15c-4.49-2.24-18.35-3.78-24.37,0,0,0-2,6.18-2.19,10.16,0,0,1.91,3.42,10.17,5.25s18.07-3.51,18.07-3.51Z",
    fill: "#005d8f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277,128.15c.06,1.66.35,3,.88,3.46,1.8,1.54,11.7-1,11.7-1a7.41,7.41,0,0,0,1-6.35l-.8-.67c-2.09-1.69-7.73-6.06-9.9-5.48C278,118.65,276.87,124.27,277,128.15Z",
    fill: "#d62828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277,128.15c.06,1.66.35,3,.88,3.46,1.8,1.54,11.7-1,11.7-1a7.41,7.41,0,0,0,1-6.35l-.8-.67c-2.37,1.05-3.26,2.87-4.06,4.59S278.79,130.75,277,128.15Z",
    fill: "#ac2020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.29,129.46c.4,3,2.29,4.19,5,4.42,3.46.31,6.57-.29,7.3-5.44.4-2.8.22-4.77-.71-6-.78-1.05-2.08-1.6-4-1.72-3.64-.26-7,.72-7.61,5.89A11.89,11.89,0,0,0,288.29,129.46Z",
    fill: "#d62828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.29,129.46c.4,3,2.29,4.19,5,4.42,3.46.31,6.57-.29,7.3-5.44.4-2.8.22-4.77-.71-6-.2,2.93-1.2,8.56-5.92,8.61C290.92,131.06,289.23,130.28,288.29,129.46Z",
    fill: "#ac2020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.31,124.9s9.56-4.48,12-3.05.44,12.5-1.72,13.51-11-4.08-11-4.08A7.4,7.4,0,0,1,299.31,124.9Z",
    fill: "#d62828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.69,237.16l-1.24-17.85c-.79-.13-23.49-9.33-25.27-9.9-.71-.23-11.43-2.1-24.31-4.12-.27,0-.52,0-.81,0-11.07-.71-15.25,13.49-15.25,13.49s-8,29.52-3.51,39.25,17,11.84,18.21,11.84,6.53-6,6.53-6,12.93,6.87,21,7.61,26.42-9,26.42-9Z",
    fill: "#ca8073"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.69,237.16c-8.15-.74-20.1-1.83-20.52-1.9-.62-.1-15.29,17.93-25.61,19-28.44,2.85-20.75-35.45-20.75-35.45s-8,29.52-3.51,39.25,17,11.84,18.21,11.84,6.53-6,6.53-6,12.93,6.87,21,7.61,26.42-9,26.42-9Z",
    fill: "#bb6a5c"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 276.54,
    y1: 224.77,
    x2: 268.57,
    y2: 248.23,
    fill: "none",
    stroke: "#192d3c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 283.66,
    y1: 239.36,
    x2: 273.73,
    y2: 258.31,
    fill: "none",
    stroke: "#192d3c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.83,213l-1.77,31.88L325.39,275s62.23,3.06,104.2-.94c19.65-1.88,34.87-5.29,37.19-11.3,1-2.51.6-6.92-.83-12.66a141.17,141.17,0,0,0-6.33-18.42c-17.7-42.95-61.7-112.21-88.23-113.73-11.6-.67-18.4,5.76-21.45,15.61-2.66,8.54-2.53,19.63-.32,30.89,4.76,24.25,28.92,51.18,28.92,51.18Z",
    fill: "#d62828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.62,164.4c4.76,24.25,28.92,51.18,28.92,51.18,15.71,3,38.95,14.11,39.67,14.46-1.24-1.31-58.35-60.73-68.27-96.53C347.28,142.05,347.41,153.14,349.62,164.4Z",
    fill: "#ac2020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.06,244.84,325.39,275s62.23,3.06,104.2-.94c19.65-1.88,34.87-5.29,37.19-11.3,1-2.51.6-6.92-.83-12.66C438.07,259.19,356.34,249,327.06,244.84Z",
    fill: "#ac2020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.59,274c19.65-1.88,34.87-5.29,37.19-11.3.94-2.47.62-6.76-.76-12.35,0-.1,0-.21-.07-.31a141.17,141.17,0,0,0-6.33-18.42c-9.26.63-23,4.67-28.11,22.11A60.5,60.5,0,0,0,429.59,274Z",
    fill: "#e36464"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.59,274c19.65-1.88,34.87-5.29,37.19-11.3.94-2.47.62-6.76-.76-12.35,0-.1,0-.21-.07-.31-7.93,2.6-20.23,3.63-34.44,3.69A60.5,60.5,0,0,0,429.59,274Z",
    fill: "#b9233e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.53,237.7s-4.25-4.83-6.59-7",
    fill: "none",
    stroke: "#192d3c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 444.8,
    y1: 239.44,
    x2: 439.57,
    y2: 234.76,
    fill: "none",
    stroke: "#192d3c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 433.64,
    y1: 265.31,
    x2: 424.62,
    y2: 266.17,
    fill: "none",
    stroke: "#192d3c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 378.37,
    cy: 263.97,
    r: 6.14,
    fill: "#192d3c"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 352.82,
    cy: 262.94,
    r: 6.14,
    fill: "#192d3c"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 339.2,
    y1: 218.29,
    x2: 336.91,
    y2: 268.33,
    fill: "none",
    stroke: "#192d3c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.51,235.59s-22.78-12.22-44-17.24A119,119,0,0,1,412,239.25",
    fill: "none",
    stroke: "#192d3c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.53,281.18a108,108,0,0,1-19.86,5.17,102.62,102.62,0,0,1-10.34,1.07c-3.46.21-7,0-10.39.36-.39,0-.54.62-.1.73a39.53,39.53,0,0,0,10.25.58,83.08,83.08,0,0,0,10.56-1.1,80.22,80.22,0,0,0,20.16-6.14c.37-.17.11-.81-.28-.67Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.38,286.56l-5.83.06a29.13,29.13,0,0,0-5.68.29c-.25.06-.26.48,0,.52a28.36,28.36,0,0,0,5.68,0l5.83-.21c.44,0,.44-.7,0-.69Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443,180a168.72,168.72,0,0,0-33.32-47.1,87.68,87.68,0,0,0-12.21-10.74c-.41-.28-.84.33-.52.67,3.31,3.48,6.95,6.65,10.33,10.07s6.57,6.84,9.66,10.43A196.18,196.18,0,0,1,434,166.55c2.87,4.55,5.56,9.21,8.1,13.94.3.56,1.1.07.84-.49Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.54,209.89c4.24,8.5,8.57,17,11.34,26.16a58.45,58.45,0,0,1,1.92,28c-.14.73.94,1.05,1.12.31,2.27-9.22.91-19.19-1.81-28.16-2.84-9.37-7.29-18.12-11.78-26.78-.27-.52-1.05-.06-.79.47Z",
    fill: "#dbb785"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.59,273.3a35.05,35.05,0,0,1-6.19,2.35c-1,.29-2.08.53-3.14.72a29.77,29.77,0,0,0-3.27.56.56.56,0,0,0,.15,1.09,11.28,11.28,0,0,0,3.37-.31c1.13-.22,2.25-.5,3.35-.83a31.67,31.67,0,0,0,6.23-2.73c.55-.32.06-1.13-.5-.85Z",
    fill: "#dbb785"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.46,200.8,453.67,197l-.36-.49a.8.8,0,0,0-.82-.28.57.57,0,0,0-.4.46.94.94,0,0,0,.3.86l1.45,1.85,1.67,2.13a.61.61,0,0,0,.95-.74Z",
    fill: "#dbb785"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.19,115.21a38.78,38.78,0,0,0-6.4-3.23c-1.09-.41-2.2-.79-3.31-1.12s-2.48-.81-3.52-.51a.53.53,0,0,0-.24.87,8.56,8.56,0,0,0,3.11,1.1c1.13.3,2.24.64,3.34,1a49.37,49.37,0,0,1,6.48,2.78.53.53,0,0,0,.54-.92Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 278.07,
    width: 511.6,
    height: 41.29,
    rx: 2,
    transform: "translate(511.6 597.44) rotate(-180)",
    fill: "#df9334"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.64,319.36H140.69c-16.89-7.33-27.37-6.58-38.71,0H87.7C110.13,302.12,126,301.08,158.64,319.36Z",
    fill: "#c17d34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.21,303.36c8-2.52,15.52-5.44,22.83-8.26,34.78-13.43,67.62-26.12,131.39,10.22a232.49,232.49,0,0,0,28.78,14H220.5q-6.44-3.23-13.08-7c-60.43-34.44-90.1-23-124.46-9.71-7.42,2.87-15.1,5.84-23.31,8.43C38.06,317.9,16.88,315,0,309.7v-8.65C16.09,306.47,36.67,309.85,57.21,303.36Z",
    fill: "#c17d34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.94,295c-14.35,1.85-30.29-2.42-41.94-6.76v-7a3.23,3.23,0,0,1,.42-1.57c11,4.3,26.82,9,40.49,7.27,7.32-.94,16.16-4.38,25.8-8.94H84.85C69,286.29,54.1,293.47,41.94,295Z",
    fill: "#c17d34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214,278.07c13.47,8.16,27.21,15.56,41,19.16,27.28,7.14,48.2,4.8,68.51-9.13v9.61c-20.91,12.66-43,14.58-70.55,7.35-18.74-4.9-36.82-16-54.31-27Z",
    fill: "#c17d34"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323.48,
    y: 278.07,
    width: 188.13,
    height: 41.29,
    rx: 2,
    transform: "translate(835.08 597.44) rotate(-180)",
    fill: "#c07732"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.52,302a150.77,150.77,0,0,1-20.81,17.36H332.43c11.86-6.26,21.8-14.61,30.4-23.11a107.59,107.59,0,0,1,23.72-18.18h24.22C397.29,279.89,383.59,287.11,368.52,302Z",
    fill: "#a2612f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.73,304.41c9,4.51,21.44,9.72,34.89,14.95H452c-6.32-2.68-12.07-5.28-16.93-7.71-23-11.48-36.17-7.87-52.67,7.71H370.92C390.4,298.94,408,289.06,438.73,304.41Z",
    fill: "#a2612f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464,283.83a221.33,221.33,0,0,0,47.64,18.64v8.41a229.81,229.81,0,0,1-51.51-19.94c-12.28-6.68-23.74-11.41-35.07-12.87h27.47C456.37,279.83,460.19,281.78,464,283.83Z",
    fill: "#a2612f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.55,284.27c-3.22-2.17-6.36-4.22-9.47-6.2h14.79c4.62,3.1,9.2,6,13.73,8.72v9.44Q502.24,290.76,492.55,284.27Z",
    fill: "#a2612f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.94,278.07H347.5a123,123,0,0,1-24,19.64V288.1A109.53,109.53,0,0,0,335.94,278.07Z",
    fill: "#a2612f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.16,268.86a9.22,9.22,0,0,0,9.21,9.21h117a9.21,9.21,0,1,0,0-18.42h-117A9.2,9.2,0,0,0,199.16,268.86Z",
    fill: "#005d8f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.16,268.86a9.22,9.22,0,0,0,9.21,9.21h56.75c-10.17-6.34-19.35-13.23-28.46-18.42H208.37A9.2,9.2,0,0,0,199.16,268.86Z",
    fill: "#003049"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.3,
    y: 265.58,
    width: 18.05,
    height: 6.56,
    rx: 2.03,
    transform: "translate(618.65 537.72) rotate(-180)",
    fill: "#182d3c"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274.66,
    y: 265.58,
    width: 18.05,
    height: 6.56,
    rx: 2.03,
    transform: "translate(567.38 537.72) rotate(180)",
    fill: "#182d3c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86,278.07H209.14a10.19,10.19,0,0,0,9.67-13.41l-34.47-103.4a16.25,16.25,0,0,0-15.41-11.11H45.81a10.19,10.19,0,0,0-9.67,13.42L70.61,267A16.23,16.23,0,0,0,86,278.07Z",
    fill: "#003049"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.16,163.58l3.19,9.57L60.61,267A16.25,16.25,0,0,0,76,278.07H199.16a10.19,10.19,0,0,0,9.66-13.42l-6.73-20.18-27.74-83.21A16.22,16.22,0,0,0,159,150.15H35.82A10.19,10.19,0,0,0,26.16,163.58Z",
    fill: "#0085cc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.35,173.15,60.61,267A16.25,16.25,0,0,0,76,278.07H199.16a10.19,10.19,0,0,0,9.66-13.42l-6.73-20.18c-16.68-9.63-40.34-17.29-76.46-23.75C77.23,212.07,45.76,189.4,29.35,173.15Z",
    fill: "#005d8f"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenComputer);
export default __webpack_public_path__ + "static/media/men_computer.71b2b025.svg";
export { ForwardRef as ReactComponent };